import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {GET, POST, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

type ServiceClassification = {
  id: string
  name: string
  description?: string
  code?: string
  order?: number
}

const Content: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [order, setOrder] = useState<number>(0)

  const getServiceClassification = async () => {
    try {
      setLoading(true)
      const res = await GET(`/service-classification/${id}`)
      
      if (res.success && res.data) {
        const classification = res.data as ServiceClassification
        setName(classification.name || '')
        setDescription(classification.description || '')
        setCode(classification.code || '')
        setOrder(classification.order || 0)
      }

      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('service_category_update.error.title')),
        text: String(i18n.t('service_category_update.error.load_data')),
      })
    }
  }

  const edit = async () => {
    try {
      if (!name) {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('service_category_create.validation.missing_fields_title')),
          text: String(i18n.t('service_category_create.validation.missing_fields_text')),
        })
      } else {
        setLoading(true)

        const res = await PUT(`/service-classification/${id}`, {
          name,
          description,
          order,
          code: code || '0',
        })

        setLoading(false)
        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: String(i18n.t('service_category_update.success.title')),
            text: String(i18n.t('service_category_update.success.text')),
          }).then(() => navigate('/hospitality/service-category'))
        } else {
          Swal.fire({
            icon: 'error',
            title: String(i18n.t('service_category_update.error.title')),
            text: String(i18n.t('service_category_update.error.text')),
          })
        }
        setLoading(false)
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('service_category_update.error.title')),
        text: String(e ?? i18n.t('service_category_update.error.update')),
      })
    }
  }

  useEffect(() => {
    getServiceClassification()
  }, [])
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(
                  `general.edit`
                )} ${i18n.t(`smart_order.service_classification`)}`}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`general.save_changes_edit`)}
                </span>
              </h3>
            </div>
            <div className='card-body '>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`smart_order.name`)}
                        label={i18n.t(`smart_order.name`)}
                        value={name}
                        change={(value: string) => setName(value)}
                      />
                    </div>
                    <div className='col-lg-6'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`smart_order.code`)}
                        label={i18n.t(`smart_order.code`)}
                        disabled
                        value={code}
                        change={(value: string) => {
                          if (value.match('^[a-zA-Z0-9_]*$') != null || value === '') {
                            setCode(value)
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className='row mt-4'>
                    <div className='col-lg-8'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`smart_order.description`)}
                        label={i18n.t(`smart_order.description`)}
                        value={description}
                        change={(value: string) => setDescription(value)}
                      />
                    </div>
                    <div className='col-lg-4'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder={i18n.t(`smart_order.order`)}
                        label={i18n.t(`smart_order.order`)}
                        value={order.toString()}
                        change={(value: string) => setOrder(parseInt(value) || 0)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='d-flex w-100'>
              <div className='col-6 d-flex justify-content-start'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate(-1)}
                  btnClass='fw-bolder m-9'
                />
              </div>
              <div className='col-6  d-flex justify-content-end'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => edit()}
                  btnClass='fw-bolder m-9'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const EditarCategorias: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.service_classifications`),
            path: 'service-category',
            isActive: true,
          },
          {title: i18n.t(`general.edit`), path: 'service-category/editar', isActive: true},
        ]}
      >
        {`${i18n.t(`general.edit`)} ${i18n.t(`smart_order.service_classification`)}`}
      </PageTitle>
      <Content />
    </>
  )
}

export {EditarCategorias}
